module.exports = __webpack_public_path__ + "static/img/data3.8704182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/data3.png
// module id = H75m
// module chunks = 13